import { useTranslation } from "react-i18next";
import Button from "../ingka/Button";
import { useEffect, useState } from "react";
import Modal, { Sheets, ModalBody, ModalHeader } from '@ingka/modal';
import style from './createEditServices.module.scss';
import { Controller, useForm } from "react-hook-form";
import DatePicker from "./DatePicker";
import { exportBills, sendEmailWithBills } from "../../services/exportServices";
import Select from "./Select";
import { useSelector } from "react-redux";
import ArrayToOption from "../../utils/arrayToOption";
import Text from '../ingka/Text';
import { Loading } from '@ingka/loading';

export default function ExportPeriod() {
  const [t] = useTranslation("global")
  const { handleSubmit, control} = useForm();
  const[modalOpen, setModalOpen] = useState(false)
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [state, setState] = useState(null)
  const [stateOptions, setStateOptions] = useState(null)
  const [disabledClick, setDisabledClick] = useState(false)
  const [exceedsDaysSelected, setExceedsDaysSelected] = useState(false)
  const states = useSelector((state) => state.global.states)
  const DAYS_LIMIT_EXPORT_OR_SEND_MAIL = 31
  const TOTAL_DAYS_LIMIT_EXPORT = 93

  useEffect(() => {
    if(states){
      setStateOptions(ArrayToOption(states, "id", "name"))
    }
  },[states])

  const goToExport = () => {
    const numberDaysSelected = daysSelected()

    if(numberDaysSelected <= TOTAL_DAYS_LIMIT_EXPORT){
      setExceedsDaysSelected(false)
      setModalOpen(false)
      setDisabledClick(true)
      const downloadDirect = numberDaysSelected <= DAYS_LIMIT_EXPORT_OR_SEND_MAIL ? true : false
      const data = {
        startOfEndDate: fromDate  === "" ? null : fromDate, 
        endOfEndDate: toDate === "" ? null : toDate,
        state: state?.value,
        requestSendMsg: t('breakdown.exportBills')
      }

      exportBills({
        ...data,
        downloadSuccess: downloadDirect ? t('breakdown.downloadSuccess') : t('breakdown.sendToEmailSuccess'),
        downloadDirect: downloadDirect,
        noLinesInPeriod: t('breakdown.noLinesInPeriod')
      }).then( () => setDisabledClick(false))
    } else {
      setExceedsDaysSelected(true)
    }
  } 

  const daysSelected = () => {
    const fromDateParse = new Date(fromDate)
    const toDateParse = new Date(toDate)
    const millisecondsDifference = toDateParse - fromDateParse
    const daysDifference = (millisecondsDifference / (1000 * 60 * 60 * 24)) + 1
    return daysDifference
  }

  return (
    <>
      <Button
        type="emphasised"
        text={t("breakdown.exportPeriod")}
        className="ml-1"
        onClick={() => setModalOpen(!modalOpen)}
        disabled={disabledClick}
        loading={disabledClick}
        qa="buttonExportPeriod"
      />

      <Modal
        visible={modalOpen}
        focusLockProps={{
          disabled: false
        }}
        handleCloseBtn={()=> setModalOpen(!modalOpen)}
        qa="exportPeriodModal"
        >
        <Sheets
          aria-label="Accessibility header for a modal"
          header={<ModalHeader className={style.modal_header} title={t("breakdown.exportPeriod")}/>}
        >
          <ModalBody >
            <form id="exportForm" className="row" onSubmit={handleSubmit(goToExport)}>
              <Controller
                control={control}
                name="fromDate"
                rules={{required: false }}
                render={({ field:{onChange, ref}, fieldState: {error}}) => (
                <DatePicker
                  qa="fromDate"
                  formField={{
                    className:"col-12",
                    shouldValidate: error !== undefined,
                    validation: {
                      id:"fromDate",
                      msg:t('validation.required'), 
                      type:"error"
                    }
                  }}
                  label={t('global.from')}
                  value={fromDate}
                  inputRef={ref}
                  onChange={(e) => {
                    setFromDate(e.target.value)
                    onChange(e.target.value)
                  }}
                />
              )} 
              />
              <Controller
                control={control}
                name="toDate"
                rules={{required: false }}
                render={({ field:{onChange, ref}, fieldState: {error}}) => (
                <DatePicker
                  qa="toDate"
                  formField={{
                    className:"col-12",
                    shouldValidate: error !== undefined,
                    validation: {
                      id:"toDate",
                      msg:t('validation.required'), 
                      type:"error"
                    }
                  }}
                  label={t('global.to')}
                  value={toDate}
                  inputRef={ref}
                  onChange={(e) => {
                    setToDate(e.target.value)
                    onChange(e.target.value)
                  }}
                />
              )} 
              />

              <Select
                formField={{className:"col-12"}}
                label={t('global.state')}
                onChange={val => setState(val)}
                value={state}
                qa="state"
                name="state"
                options={stateOptions}
              />
            </form>
            {exceedsDaysSelected &&
              <Text tagName="p" className="text-red">{t('breakdown.exceedsDays',{days: TOTAL_DAYS_LIMIT_EXPORT})}</Text>
            }
          </ModalBody>
          <div className={style.submit}>
            <Button
              type="emphasised"
              text={t("global.export")}
              form="exportForm"
              htmlType="submit"
              disabled={toDate === "" && fromDate === "" && state === null}
            />
          </div>
        </Sheets>
      </Modal>
    </>
  )
}
